import React from "react";

const Para = ({ text, myClass }) => {
  return (
    <p
      className={`${myClass} fond-normal sm:text-base text-sm leading-[130%] ff-sans`}
    >
      {text}
    </p>
  );
};

export default Para;
